export default "__VITE_ASSET__Q4E0Cc6w__"